// extracted by mini-css-extract-plugin
export default {"tableCell":"CourseReviews_tableCell__6ZT6C","tableRoot":"CourseReviews_tableRoot__Th7KM","search":"CourseReviews_search__S-CCc"};